export default {
  props: {
    dataList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    handleClick: function handleClick(item) {
      this.$emit('send', item);
    }
  }
};